export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
        $( document ).ready(function() {
            $('.hero-slider').flickity({
                // options
                cellAlign: 'left',
                contain: true,
                autoPlay: true,
                accessibility: true,
                prevNextButtons: true,
                pageDots: true,
                wrapAround: true,
            });
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js